var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTerminal = function SvgTerminal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1H19V15H1V1Z",
    fill: "currentColor",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.16349 0.819014C0 1.13988 0 1.55992 0 2.4V13.6C0 14.4401 0 14.8601 0.16349 15.181C0.3073 15.4632 0.536771 15.6927 0.819014 15.8365C1.13988 16 1.55992 16 2.4 16H17.6C18.4401 16 18.8601 16 19.181 15.8365C19.4632 15.6927 19.6927 15.4632 19.8365 15.181C20 14.8601 20 14.4401 20 13.6V2.4C20 1.55992 20 1.13988 19.8365 0.819014C19.6927 0.536771 19.4632 0.3073 19.181 0.16349C18.8601 0 18.4401 0 17.6 0H2.4C1.55992 0 1.13988 0 0.819014 0.16349C0.536771 0.3073 0.3073 0.536771 0.16349 0.819014ZM5.41935 3.81456C4.83091 3.35702 3.98007 3.39861 3.43934 3.93934L3.31456 4.08065C2.85702 4.66909 2.89861 5.51993 3.43934 6.06066L5.3775 8L3.43934 9.93934L3.31456 10.0807C2.85702 10.6691 2.89861 11.5199 3.43934 12.0607C4.02513 12.6464 4.97487 12.6464 5.56066 12.0607L8.56066 9.06066L8.68544 8.91935C9.14298 8.33091 9.10139 7.48007 8.56066 6.93934L5.56066 3.93934L5.41935 3.81456Z",
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTerminal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "terminal.e98fab6867aa510c4efb4a00df698de3.svg";